import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { StockOrderFilter } from "../../../../../../api/stockOrders";

/** Значения формы фильтра списка приходных ордеров для размещения ТМЦ. */
export interface StockPlacementFilterFormValues {
    /** Номер приходного ордера. */
    num: string;
    /** Код склада. */
    divisionCode: number | null;
    /** Коды статусов приходного ордера. */
    stateCodes: number[];
}

/** Конфигурация фильтра приходных ордеров для задачи размещения ТМЦ. */
export const stockPlacementFilterFormConfig = defineFilterConfig<StockPlacementFilterFormValues, StockOrderFilter>({
    fields: {
        num: {
            type: "string",
            label: "Номер ПО",
            map: {
                from: (domain) => domain.Num ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { Num: trimmed === "" ? undefined : trimmed };
                },
            },
        },
        divisionCode: {
            type: "number",
            nullable: true,
            label: "Склад",
            map: {
                from: (domain) => domain.DivisionCode ?? null,
                to: (value) => ({ DivisionCode: value ?? undefined }),
            },
        },
        stateCodes: {
            type: "array",
            label: "Статусы ПО",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
